import {
  FETCH_CASHBACK_FAILED,
  FETCH_CASHBACK_START,
  FETCH_CASHBACK_SUCCESS
} from "./actionTypes";

export const fetchCashbackStart = (params = {}) => {
  return {
    type: FETCH_CASHBACK_START,
    payload: params
  };
};
export const fetchCashbackSuccess = (params) => {
  return {
    type: FETCH_CASHBACK_SUCCESS,
    payload: params
  };
};
export const fetchCashbackFailed = () => {
  return {
    type: FETCH_CASHBACK_FAILED,
  };
};